import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { isFromSearch } from 'lib/utils/query-params'
import styles from './BackToSearch.module.scss'

export default function BackToSearch({ fixed = false }) {
  const [shouldShow, setShouldShow] = useState(false)
  const router = useRouter()

  const getClasses = () => {
    if (fixed) {
      return `${styles.section} ${styles.fixed}`
    }

    return styles.section
  }

  useEffect(() => {
    if (isFromSearch(router)) {
      setShouldShow(true)
    }
  }, [router.query])

  if (!shouldShow) return null

  return (
    <section className={getClasses()}>
      <div className="container">
        <p className={styles.back} role="button" onClick={router.back}>
          <img
            src="/img/arrow-pink.svg"
            className={styles.arrow}
            role="presentation"
            alt=""
            width="13"
            height="13"
            loading="lazy"
          />
          Takaisin hakuun
        </p>
      </div>
    </section>
  )
}
